import { Box, Heading, Text } from "@chakra-ui/layout"
import { Flex } from "@chakra-ui/react"
import { Image } from "./Image"

export function ImageMultiText({ image, textArray }) {
  return (
    <Box bg="#F3F3F3">
      <Box maxW="1440px" m="0 auto">
        <Flex
          p={{ base: `0  0 34px 0`, md: `67px 0` }}
          flexWrap={{ base: `wrap`, md: `nowrap` }}
          flexDirection={{ base: `row-reverse`, md: `row` }}
        >
          <Box
            flex={{ base: `0 0 100%`, md: "1 0 0px" }}
            display={{ base: `block`, md: `none` }}
            mb={{ base: `50px`, md: 0 }}
          >
            {image?.localFile?.childImageSharp && (
              <Image image={image.localFile.childImageSharp} />
            )}
          </Box>
          <Box
            flex={{ base: `0 0 100%`, md: "1 0 0px" }}
            mr={{ base: 0, md: "75px" }}
            p={{ base: `0 20px`, md: 0 }}
          >
            {textArray.map(({ title, description }) => {
              return (
                <Box maxW="500px" m="0 0 35px auto">
                  <Heading
                    fontWeight="500"
                    fontSize={{ base: `36px`, md: "60px" }}
                    letterSpacing={{ base: `-1px`, md: "-0.37px" }}
                    textAlign={{ base: `center`, md: "right" }}
                    lineHeight={{ base: `31px`, md: "50px" }}
                    mb="25px"
                  >
                    {title}
                  </Heading>
                  <Text
                    fontSize={{ base: `16px`, md: "20px" }}
                    lineHeifght={{ base: `22px`, md: "28px" }}
                    color="black"
                    textAlign={{ base: `center`, md: "right" }}
                  >
                    {description}
                  </Text>
                </Box>
              )
            })}
          </Box>
          <Box
            flex={{ base: `0 0 100%`, md: "1 0 0px" }}
            display={{ base: `none`, md: `block` }}
          >
            {image?.localFile?.childImageSharp && (
              <Image image={image.localFile.childImageSharp} />
            )}
          </Box>
        </Flex>
      </Box>
    </Box>
  )
}
